<template>
  <summary-button
    :goToRoute="goToRoute"
    :quantity="amountInCart"
    :currency="highestTotalByCurrency ? highestTotalByCurrency.currency : null"
    :total="highestTotalByCurrency ? highestTotalByCurrency.amount : null"
    :compact="compact"
    :disabled="disabled"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import reservationMixins from '@/mixins/Reservation'
export default {
  props: {
    compact: Boolean,
    goToRoute: String,
  },
  components: {
    SummaryButton: () => import('@/components/view-components/catalog/SummaryButton.vue'),
  },
  computed: {
    disabled () {
      return this.reservationMethod.preOrder === 'MANDATORY' && !this.cart.cartProducts.length
    },
    ...mapState(['cart']),
    ...mapGetters({
      reservationMethod: 'activityReservations/reservationMethod',
    }),
  },
  mixins: [
    reservationMixins,
  ],
}
</script>

<style lang="scss">
</style>
